export const PERSONAL_DATA_MODAL_PARAM_KEY = 'personal_data';
